import { render, staticRenderFns } from "./AdminboardLayout.vue?vue&type=template&id=7a421c15"
import script from "./AdminboardLayout.vue?vue&type=script&lang=js"
export * from "./AdminboardLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminboardLayout.vue?vue&type=style&index=0&id=7a421c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports